import { useState, useEffect } from 'react';
import { getDoctor, getDoctorSchedule, getPatients, getWhatsAppTemplates } from '../services/api';

export const useCalendarData = (doctorId) => {
  const [doctor, setDoctor] = useState(null);
  const [businessHours, setBusinessHours] = useState(false);
  const [patients, setPatients] = useState([]);
  const [waTemplates, setWaTemplates] = useState([]);

  useEffect(() => {
    if (!doctorId) return;

    getDoctor(doctorId)
      .then(r => setDoctor(r.data))
      .catch(() => {});

    getDoctorSchedule(doctorId)
      .then(r => {
        const slots = r.data || [];
        if (!slots.length) { setBusinessHours(false); return; }
        setBusinessHours(slots.map(s => ({
          daysOfWeek: [(s.day_of_week + 1) % 7],
          startTime: s.time_start,
          endTime: s.time_end,
        })));
      })
      .catch(() => setBusinessHours(false));

    getPatients({ limit: 500 })
      .then(r => setPatients(r.data?.items || []))
      .catch(() => {});

    getWhatsAppTemplates()
      .then(r => setWaTemplates(r.data || []))
      .catch(() => {});
  }, [doctorId]);

  return { doctor, businessHours, patients, setPatients, waTemplates };
};
